import axios from 'axios';

import {
    BRAND__FETCH_SITE__START,
    BRAND__FETCH_SITE__SUCCESS,
    BRAND__FETCH_SITE__FAILURE,
    BRAND__FETCH_FRAME__START,
    BRAND__FETCH_FRAME__SUCCESS,
    BRAND__FETCH_FRAME__FAILURE,
    BRAND__FETCH_STATUS__START,
    BRAND__FETCH_STATUS__SUCCESS,
    BRAND__FETCH_STATUS__FAILURE,
    BRAND__FETCH_DC__START,
    BRAND__FETCH_DC__SUCCESS,
    BRAND__FETCH_DC__FAILURE,
    BRAND__SMS_SEND__START,
    BRAND__SMS_SEND__SUCCESS,
    BRAND__SMS_SEND__FAILURE,
    BRAND__SMS_CHECK__START,
    BRAND__SMS_CHECK__SUCCESS,
    BRAND__SMS_CHECK__FAILURE,
    BRAND__ERROR_CHECK__START,
    BRAND__ERROR_CHECK__SUCCESS,
    BRAND__ERROR_CHECK__FAILURE,
} from './actions';

function fetchSiteStart() {
    return {
        type: BRAND__FETCH_SITE__START,
    };
}

function fetchSiteSuccess(data) {
    return {
        type: BRAND__FETCH_SITE__SUCCESS,
        data,
    };
}

function fetchSiteFailure(error) {
    return {
        type: BRAND__FETCH_SITE__FAILURE,
        error,
    };
}

export function fetchSite(dealerCenterId) {
    const data = {
        data: {
            sector: `${dealerCenterId}`,
        },
    };
    return dispatch => {
        dispatch(fetchSiteStart());
        return axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/merchant/find`, { ...data }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.data) {
                    const {
                        errorCode,
                        errorMessage,
                        orderId,
                    } = response.data.data;

                    const error = errorMessage || errorCode;

                    if (orderId) {
                        dispatch(fetchSiteSuccess(response.data.data));
                    } else {
                        throw new Error(error);
                    }
                } else {
                    dispatch(fetchSiteFailure(true));
                }
            })
            .catch(error => {
                dispatch(fetchSiteFailure(new Error(error)));
            });
    };
}

function fetchFrameStart() {
    return {
        type: BRAND__FETCH_FRAME__START,
    };
}

function fetchFrameSuccess(data) {
    return {
        type: BRAND__FETCH_FRAME__SUCCESS,
        data,
    };
}

function fetchFrameFailure(error) {
    return {
        type: BRAND__FETCH_FRAME__FAILURE,
        error,
    };
}

export function fetchFrame(token) {
    return dispatch => {
        dispatch(fetchFrameStart());
        if (token.search('fail') !== -1) {
            dispatch(fetchFrameFailure(new Error('Некорректный url в адресной строке.')));
            return null;
        }
        return axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/pay/frame/${token}`, {}, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.data) {
                    const {
                        errorCode,
                        errorMessage,
                        orderId,
                    } = response.data.data;

                    const error = errorMessage || errorCode || response.data.errorMessage || response.data.errorCode;

                    if (orderId) {
                        dispatch(fetchFrameSuccess(response.data.data));
                    } else {
                        dispatch(fetchFrameFailure(error));
                    }
                } else {
                    dispatch(fetchFrameFailure(true));
                }
            })
            .catch(error => {
                dispatch(fetchFrameFailure(new Error(error)));
            });
    };
}

function fetchStatusStart() {
    return {
        type: BRAND__FETCH_STATUS__START,
    };
}

function fetchStatusSuccess(data) {
    return {
        type: BRAND__FETCH_STATUS__SUCCESS,
        data,
    };
}

function fetchStatusFailure(error) {
    return {
        type: BRAND__FETCH_STATUS__FAILURE,
        error,
    };
}

const RETRY_ERROR_CODE = 8013;

const getStatusInfo = (dispatch,baseUrl, operationId, retry = 2, callBack) => {
    let interval = callBack;
    clearInterval(callBack)
    return axios.post(baseUrl, { ...(Number(operationId) ? { data: { operationId: Number(operationId) } } : {}) }, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
            if (response.status === 200 && response.data && response.data.data) {
                const {
                    data: {
                        errorCode,
                        errorMessage,
                    },
                } = response;
                if (errorCode === RETRY_ERROR_CODE && retry !== 0) {
                    console.log({retry, interval, errorCode})
                    interval = setInterval(() => {
                        getStatusInfo(dispatch, baseUrl, operationId, retry - 1, interval)
                    }, 5000)
                } else {
                    if (errorMessage || errorCode) {
                        throw new Error(errorMessage || errorCode);
                    }
                    dispatch(fetchStatusSuccess(response.data.data));
                }
            } else {
                dispatch(fetchStatusFailure(true));
            }
        })
        .catch(error => {
            dispatch(fetchStatusFailure(new Error(error)));
        });
}

export function fetchStatus(search) {
    return dispatch => {
        dispatch(fetchStatusStart());
        let baseUrl = '';
        let operationId;
        if (search.pathname.search('check') !== -1) {
            const pathNameParts = search.pathname.split('/');
            baseUrl = `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/pay/status/token/${pathNameParts[pathNameParts.length - 1]}`;
        } else {
            if (search.search.length === 0) {
                dispatch(fetchStatusFailure('Невозможно запросить статус платежа. В адресной строке нет id для запроса. Возможно, url некорректен'));
                return null;
            }
            const orderId = /(?:id=)(?<orderId>[^&$]*)/.exec(search?.search)?.groups?.orderId || 'no-order-id';
            operationId = /(?:&operation=)(?<operationId>[^&$]*)/.exec(search?.search)?.groups?.operationId || null;
            baseUrl = `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/pay/status/id/${orderId}`;
        }
        getStatusInfo(dispatch,baseUrl, operationId)
    };
}

function fetchDCStart() {
    return {
        type: BRAND__FETCH_DC__START,
    };
}

function fetchDCSuccess(data) {
    return {
        type: BRAND__FETCH_DC__SUCCESS,
        data,
    };
}

function fetchDCFailure(error) {
    return {
        type: BRAND__FETCH_DC__FAILURE,
        error,
    };
}

export function fetchDC(dealerCenterId) {
    const data = {
        data: {
            sector: `${dealerCenterId}`,
        },
    };
    return dispatch => {
        dispatch(fetchDCStart());

        return axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/merchant/find`, { ...data }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.data) {
                    const {
                        data: {
                            errorCode,
                            errorMessage,
                        },
                    } = response;
                    if (errorMessage || errorCode) {
                        throw new Error(errorMessage || errorCode);
                    }
                    dispatch(fetchDCSuccess(response.data.data));
                } else {
                    dispatch(fetchDCFailure(true));
                }
            })
            .catch(error => {
                dispatch(fetchDCFailure(new Error(error)));
            });
    };
}

export function someRandomRequest() {
    return axios.post('some random url', {}, { headers: { 'Content-Type': 'application/json' } })
        .then(response => response);
}

function sendSMSStart() {
    return {
        type: BRAND__SMS_SEND__START,
    };
}

function sendSMSSuccess(data) {
    return {
        type: BRAND__SMS_SEND__SUCCESS,
        data,
    };
}

function sendSMSFailure(error) {
    return {
        type: BRAND__SMS_SEND__FAILURE,
        error,
    };
}

export function sendSMS(token) {
    return dispatch => {
        dispatch(sendSMSStart());

        return axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/sms/send`,
            { data: { token } }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.data) {
                    const {
                        data: {
                            errorCode,
                            errorMessage,
                        },
                    } = response;
                    if (errorMessage || errorCode) {
                        throw new Error(errorMessage || errorCode);
                    }
                    dispatch(sendSMSSuccess(response.data.data));
                } else {
                    dispatch(sendSMSFailure(true));
                }
            })
            .catch(error => {
                dispatch(sendSMSFailure(new Error(error)));
            });
    };
}

function checkSMSStart() {
    return {
        type: BRAND__SMS_CHECK__START,
    };
}

function checkSMSSuccess(data) {
    return {
        type: BRAND__SMS_CHECK__SUCCESS,
        data,
    };
}

function checkSMSFailure(error) {
    return {
        type: BRAND__SMS_CHECK__FAILURE,
        error,
    };
}

export function checkSMS(token, code) {
    return dispatch => {
        dispatch(checkSMSStart());

        return axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/sms/check`,
            { data: { token, code } }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.data) {
                    const {
                        data: {
                            errorCode,
                            errorMessage,
                        },
                    } = response;
                    if (errorMessage || errorCode) {
                        throw new Error(errorMessage || errorCode);
                    }
                    dispatch(checkSMSSuccess(response.data.data));
                } else {
                    dispatch(checkSMSFailure(true));
                }
            })
            .catch(error => {
                dispatch(checkSMSFailure(new Error(error)));
            });
    };
}

function checkErrorStart() {
    return {
        type: BRAND__ERROR_CHECK__START,
    };
}

function checkErrorSuccess(data) {
    return {
        type: BRAND__ERROR_CHECK__SUCCESS,
        data,
    };
}

function checkErrorFailure(error) {
    return {
        type: BRAND__ERROR_CHECK__FAILURE,
        error,
    };
}

export function checkError(code) {
    return dispatch => {
        dispatch(checkErrorStart());

        return axios.post(`${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/error/code`,
            { data: { code } }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200 && response.data && response.data.errorDescription) {
                    const {
                        data: {
                            errorCode,
                            errorMessage,
                        },
                    } = response;
                    if (errorMessage || errorCode) {
                        throw new Error(errorMessage || errorCode);
                    }
                    dispatch(checkErrorSuccess(response.data));
                } else {
                    dispatch(checkErrorFailure(true));
                }
            })
            .catch(error => {
                dispatch(checkErrorFailure(new Error(error)));
            });
    };
}
